import '../Input/Input.scss';
const index = () => {
    return <div className="Input" />;
};

export default index;
